import React from "react";
import styled from "@emotion/styled";
import { Box } from "@mui/material";
import UpIcon from "@icons/positive.svg?react";
import DownIcon from "@icons/negative.svg?react";
import { getNumberColor } from "@helpers/numberColor";
import {
  MandatorTypography,
  MandatorTypographyProps,
} from "@components/MandatorTypography";

const ArrowContainer = styled.div<{ positive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme, positive }) =>
    positive ? theme.palette.text.positive : theme.palette.text.negative};
`;

const Container = styled(MandatorTypography)<{ value: number }>`
  color: ${({ theme, value }) => getNumberColor(theme, value)};
`;

export interface GainLossTypographyProps extends MandatorTypographyProps {
  value: number;
  showIndicator?: boolean;
  iconSize?: string;
}

export const GainLossTypography = ({
  value,
  showIndicator = false,
  iconSize = "8px",
  ...props
}: GainLossTypographyProps) => (
  <Box display="flex" alignItems="center" gap={1.5} {...props}>
    <Container value={value} {...props} />
    {showIndicator && (
      <ArrowContainer positive={value > 0}>
        {value > 0 && <UpIcon width={iconSize} />}
        {value < 0 && <DownIcon width={iconSize} />}
      </ArrowContainer>
    )}
  </Box>
);
